<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.has-text-centered
            h1.title Seccion de Descargas
              | &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
            br
        .columns
          .column.is-12.has-text-centered
            .field
              input.is-checkradio.is-primary(type='radio'  id="rdAsig" value="1" v-model.number="tipo")
              label.is-size-6(for="rdAsig") Asignados
              input.is-checkradio.is-primary(type='radio'  id="rdAlm" value="0" v-model.number="tipo")
              label.is-size-6(for="rdAlm") Almacenes
              input.is-checkradio.is-primary(type='radio'  id="rdMaq" value="2" v-model.number="tipo")
              label.is-size-6(for="rdMaq") Maquinaria
        hr
        div(v-show="tipo == 1")
          .columns
            .column.is-3
              b
                | Selecciona La Cede
            .column.is-9
              .columns
                .column
                  .field
                    input.is-checkradio.is-primary(type='checkbox'  id="chAll" v-model="allSedes")
                    label.is-size-6(for="chAll") 
                    strong  Todas las Sedes
              .columns
                .column
                  .field
                    input.is-checkradio.is-primary(type='checkbox'  id="chIRGE" value="IRGE" v-model="sedes")
                    label.is-size-6(for="chIRGE") IRGE
                    input.is-checkradio.is-primary(type='checkbox'  id="chTPA" value="TPA" v-model="sedes")
                    label.is-size-6(for="chTPA") TPA
                    input.is-checkradio.is-primary(type='checkbox'  id="chCorpo" value="CORPO" v-model="sedes")
                    label.is-size-6(for="chCorpo") CORPO
                    input.is-checkradio.is-primary(type='checkbox'  id="chDucto" value="DUCTO" v-model="sedes")
                    label.is-size-6(for="chDucto") DUCTO
          hr
          .columns
            .column.is-3
              b
                | Selecciona el Área
            .column.is-9
              .columns
                .column
                  .field
                    input.is-checkradio.is-primary(type='checkbox'  id="chAllAreas" v-model="allAreas")
                    label.is-size-6(for="chAllAreas") 
                      strong  Todas las Áreas
              .columns
                .column
                  .field
                    input.is-checkradio.is-primary(type='checkbox'  id="ch_i" value="i" v-model="areas")
                    label.is-size-6(for="ch_i") Instrumentacion
                    input.is-checkradio.is-primary(type='checkbox'  id="ch_s" value="s" v-model="areas")
                    label.is-size-6(for="ch_s") Sistemas
                    input.is-checkradio.is-primary(type='checkbox'  id="ch_a_1" value="a-1" v-model="areas")
                    label.is-size-6(for="ch_a_1") Transporte
                    input.is-checkradio.is-primary(type='checkbox'  id="ch_a_2" value="a-2" v-model="areas")
                    label.is-size-6(for="ch_a_2") Comunicaciones
              .columns
                .column
                  .field
                    input.is-checkradio.is-primary(type='checkbox'  id="ch_a_3" value="a-3" v-model="areas")
                    label.is-size-6(for="ch_a_3") Mobiliario
                    input.is-checkradio.is-primary(type='checkbox'  id="ch_a_5" value="a-5" v-model="areas")
                    label.is-size-6(for="ch_a_5") Tags
                    input.is-checkradio.is-primary(type='checkbox'  id="ch_a_6" value="a-6" v-model="areas")
                    label.is-size-6(for="ch_a_6") Si Vale
                    input.is-checkradio.is-primary(type='checkbox'  id="ch_a_7" value="a-7" v-model="areas")
                    label.is-size-6(for="ch_a_7") Herramientas
          hr
        div(v-show="tipo == 0")
          .columns
            .column.is-3
              b
                | Selecciona el Almacén
            .column.is-9
              .columns
                .column
                  .field
                    input.is-checkradio.is-primary(type='checkbox'  id="chAllAlm" v-model="allAlmacenes")
                    label.is-size-6(for="chAllAlm") 
                      strong Todos los Almacenes
              .columns
                .column
                  .field
                    input.is-checkradio.is-primary(type='checkbox'  id="chIrgeAlm" value="IRGE" v-model="almacenes")
                    label.is-size-6(for="chIrgeAlm") IRGE
                    input.is-checkradio.is-primary(type='checkbox'  id="chTpaAlm" value="TPA" v-model="almacenes")
                    label.is-size-6(for="chTpaAlm") TPA
                    input.is-checkradio.is-primary(type='checkbox'  id="chCorpoAlm" value="CORPO" v-model="almacenes")
                    label.is-size-6(for="chCorpoAlm") CORPO
                    input.is-checkradio.is-primary(type='checkbox'  id="chEB00Alm" value="EB00" v-model="almacenes")
                    label.is-size-6(for="chEB00Alm") EB00
                    input.is-checkradio.is-primary(type='checkbox'  id="chEB01Alm" value="EB01" v-model="almacenes")
                    label.is-size-6(for="chEB01Alm") EB01
                    input.is-checkradio.is-primary(type='checkbox'  id="chEB02Alm" value="EB02" v-model="almacenes")
                    label.is-size-6(for="chEB02Alm") EB02
                    input.is-checkradio.is-primary(type='checkbox'  id="chEB03Alm" value="EB03" v-model="almacenes")
                    label.is-size-6(for="chEB03Alm") EB03
                    input.is-checkradio.is-primary(type='checkbox'  id="chEB04Alm" value="EB04" v-model="almacenes")
                    label.is-size-6(for="chEB04Alm") EB04
              .columns
                .column
                  .field
                    input.is-checkradio.is-primary(type='checkbox'  id="chTpagGAlm" value="TPAGia" v-model="almacenes")
                    label.is-size-6(for="chTpagGAlm") TPA GIA
                    input.is-checkradio.is-primary(type='checkbox'  id="chCorpoGAlm" value="CORPOGia" v-model="almacenes")
                    label.is-size-6(for="chCorpoGAlm") CORPO GIA
                    input.is-checkradio.is-primary(type='checkbox'  id="chEB04GAlm" value="EB04Gia" v-model="almacenes")
                    label.is-size-6(for="chEB04GAlm") EB04 GIA
          hr
        .columns(v-show="datosFaltantes.length > 0")
          .column.is-12
            .notification
              button.delete(@click="closeNotification")
              .field.is-grouped.is-grouped-multiline
                .control(v-for="datosF in datosFaltantes")
                  .tags
                    span.tag.is-danger 
                      b {{ datosF }}
        .columns(v-show="messageDownload !== ''")
          .column.is-12
            .notification
              span.tag {{ messageDownload }}
              i.fa.fa-spinner.fa-spin(style="font-size:18px")
        .columns
          .column.is-offset-4.is-4
            a.button.is-black.is-rounded.is-block(@click="checkForm")
              | Descargar
        .columns.column-blanco
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import InventarioServices from '../../services/inventario/inventario'
  import { mapState } from 'vuex'
  export default {
    name: 'DescargasAsinaciones',
    components: { Loader, NavBarInventario },
    data() {
      return {
        isLoading: true,
        userNormal: false,
        allSedes: false,
        sedes: [],
        allAreas: false,
        areas: [],
        datosFaltantes: [],
        messageDownload: '',
        objSedesDownload: {},
        objAreasDownload: {},
        maquinaria: false,
        tipo: 1,
        almacenes: [],
        allAlmacenes: false,
      }
    },
    watch: {
      allSedes() {
        if (this.allSedes) {
          this.sedes.length = 0
          this.sedes.push('IRGE')
          this.sedes.push('TPA')
          this.sedes.push('CORPO')
          this.sedes.push('DUCTO')
        } else {
          if (this.sedes.length == 4) {
            this.sedes.length = 0
          }
        }
      },

      sedes() {
        this.messageDownload = ''
        if (this.sedes.length == 4) {
          this.allSedes = true
        } else {
          this.allSedes = false
        }
      },

      allAreas() {
        if (this.allAreas) {
          this.areas.length = 0
          this.areas.push('i')
          this.areas.push('s')
          this.areas.push('a-1')
          this.areas.push('a-2')
          this.areas.push('a-3')
          this.areas.push('a-5')
          this.areas.push('a-6')
          this.areas.push('a-7')
        } else {
          if (this.areas.length == 8) {
            this.areas.length = 0
          }
        }
      },

      areas() {
        this.messageDownload = ''
        if (this.areas.length == 8) {
          this.allAreas = true
        } else {
          this.allAreas = false
        }
      },

      allAlmacenes() {
        if (this.allAlmacenes) {
          this.almacenes.length = 0
          this.almacenes.push('IRGE')
          this.almacenes.push('TPA')
          this.almacenes.push('CORPO')
          this.almacenes.push('EB00')
          this.almacenes.push('EB01')
          this.almacenes.push('EB02')
          this.almacenes.push('EB03')
          this.almacenes.push('EB04')
          this.almacenes.push('TPAGia')
          this.almacenes.push('CORPOGia')
          this.almacenes.push('EB04Gia')
        } else {
          if (this.almacenes.length == 11) {
            this.almacenes.length = 0
          }
        }
      },

      almacenes() {
        this.messageDownload = ''
        if (this.almacenes.length == 11) {
          this.allAlmacenes = true
        } else {
          this.allAlmacenes = false
        }
      },
    },
    methods: {
      iniciarComponente() {
        if (this.userLogin.cargo ==='331' || this.userLogin.cargo ==='332' || this.userLogin.cargo ==='323' || this.userLogin.cargo === '000' || this.userLogin.cargo === '003' || this.userLogin.cargo === '230' || this.userLogin.cargo === '210' || this.userLogin.cargo === '002' || this.userLogin.cargo === '2100' || this.userLogin.cargo === '321' || this.userLogin.cargo === '241' || this.userLogin.cargo === '324') {
          this.userNormal = false
        } else {
          this.userNormal = true
        }
        this.isLoading = false
      },
      checkForm () {
        this.closeNotification()
        switch (this.tipo) {
          case 2:
            this.donwloadFile()
            break
          case 1:
            if (this.sedes.length > 0 && this.areas.length > 0) {
            this.donwloadFile()
            } else {
              if (this.sedes.length < 1) {
                this.datosFaltantes.push('Debes seleccionar una sede.')
              }
              if (this.areas.length < 1) {
                this.datosFaltantes.push('Debes seleccionar una área.')
              }
            }
            break
          case 0:
            if (this.almacenes.length > 0) {
            this.donwloadFile()
            } else {
              if (this.almacenes.length < 1) {
                this.datosFaltantes.push('Debes seleccionar un Almacén.')
              }
            }
            break
        }
      },
      donwloadFile () {
        switch (this.tipo) {
          case 2:
            InventarioServices.descargarMaquinaria()
            .then( data => {
              if (data.success) {
                const currentUrl = window.location.hostname
                open(`https://${currentUrl}/reportesApp/server/excel/generarResguardo_All.php?nameFile=${data.file}`, '_blank')
                setTimeout(() => {
                  InventarioServices.borrarFile_InventarioUser(data.file)
                    .then( resDel => {
                      console.log(resDel)
                      this.messageDownload = ''
                    })
                }, 4000)
              } else {
                this.displayToast('bubble',data.respuesta, 'ban', 'OK')
              }
            })
            .catch((e=> {
              this.messageDownload = ''
              this.displayToast('bubble',e.message, 'ban', 'OK')
            }))
            break
          case 0:
            this.displayToast('toasted-primary','Pendiente terminar descarga de Almacenes','ban', 'OK')
            break

          case 1:
            this.objSedesDownload = {}
            this.messageDownload = "Descargando asignaciones sede: "
            let _areas = ''
            this.sedes.map( (sede, index) => {
              this.messageDownload += `${sede}`
              if (index != this.sedes.length -1) {
                this.messageDownload += ', '
              }
            })
            this.objSedesDownload.tpa = this.sedes.includes('TPA')
            this.objSedesDownload.irge = this.sedes.includes('IRGE')
            this.objSedesDownload.ducto = this.sedes.includes('DUCTO')
            this.objSedesDownload.corpo = this.sedes.includes('CORPO')
            this.objSedesDownload.all = this.sedes.length == 4 
    
            this.messageDownload += ' con área: '
    
            this.areas.map( (area, index) => {
              let areaStr = ''
              _areas += area
              switch (area) {
                case 'i':
                  areaStr = 'Instrumentación'
                  break
                case 's':
                  areaStr = 'Sistemas'
                  break
                case 'a-1':
                  areaStr = 'Transporte'
                  break
                case 'a-2':
                  areaStr = 'Comunicaciones'
                  break
                case 'a-3':
                  areaStr = 'Mobiliario'
                  break
                case 'a-5':
                  areaStr = 'Tags'
                  break
                case 'a-6':
                  areaStr = 'Si Vale'
                  break
                case 'a-7':
                  areaStr = 'Herramientas'
                  break
                case 'a-8':
                  areaStr = 'Maquinaria'
                  break
                default:
                  
                  break
                
              }
              this.messageDownload += `${areaStr}`
              if (index != this.areas.length -1) {
                this.messageDownload += ', '
                _areas += '|'
              }
            })
            this.objAreasDownload.i = this.areas.includes('i')
            this.objAreasDownload.s = this.areas.includes('s')
            this.objAreasDownload.a1 = this.areas.includes('a-1')
            this.objAreasDownload.a2 = this.areas.includes('a-2')
            this.objAreasDownload.a3 = this.areas.includes('a-3')
            this.objAreasDownload.a5 = this.areas.includes('a-5')
            this.objAreasDownload.a6 = this.areas.includes('a-6')
            this.objAreasDownload.a7 = this.areas.includes('a-7')
            this.objAreasDownload.all = this.areas.length == 8
            
            const currentUrl = window.location.hostname
            InventarioServices.descargarAsignaciones(this.objSedesDownload.irge, this.objSedesDownload.tpa, this.objSedesDownload.ducto, 
            this.objSedesDownload.corpo, this.objAreasDownload.i, this.objAreasDownload.s, this.objAreasDownload.a1, this.objAreasDownload.a2,
            this.objAreasDownload.a3,this.objAreasDownload.a5,this.objAreasDownload.a6,this.objAreasDownload.a7,
            this.objSedesDownload.all, this.objAreasDownload.all)
              .then( data => {
                if (data.success) {
                  open(`https://${currentUrl}/reportesApp/server/excel/generarResguardo_All.php?nameFile=${data.file}`, '_blank')
                  setTimeout(() => {
                    InventarioServices.borrarFile_InventarioUser(data.file)
                      .then( resDel => {
                        console.log(resDel)
                        this.messageDownload = ''
                      })
                  }, 4000)
                } else {
                  this.displayToast('bubble',data.respuesta, 'ban', 'OK')
                }
              })
              .catch((e=> {
                this.messageDownload = ''
                this.displayToast('bubble',e.message, 'ban', 'OK')
              }))
            break
        }
      },
      closeNotification () {
        this.datosFaltantes = []
      },
      backPage () {
        this.$router.back()
      },
      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin', 'areaAsignacion'])
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/inventario_Componentes/DescargasAsignaciones.vue